import { render, staticRenderFns } from "./articleClassification.vue?vue&type=template&id=576426bb&scoped=true&"
import script from "./articleClassification.vue?vue&type=script&lang=js&"
export * from "./articleClassification.vue?vue&type=script&lang=js&"
import style0 from "./articleClassification.vue?vue&type=style&index=0&id=576426bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576426bb",
  null
  
)

export default component.exports